import { Search } from '@local/client-contracts';

export type ResultsFilterEventOperation = 'add' | 'remove' | 'change' | 'clearall' | 'delete' | 'set' | 'clearParams';
export interface ResultsFilterEvent {
  operation: ResultsFilterEventOperation;
  name: string;
  value: string | Search.Sort;
}
